import {IHelpLink} from "@/models/onlineHelp.model";


export class onlineHelp {

  public static readonly QualityGuideLink = 'https://www.kogeet.com/structurer-demarche-qualite'
  public static readonly ScreenStoreGuideLink = 'https://www.kogeet.com/guide-magasin-ecrans'
  public static readonly BuildTestGuideLink = 'https://www.kogeet.com/guide-construction-cas-de-test'
  public static readonly TestTerminalsLink = 'https://www.kogeet.com/guide-installation-terminaux-test'
  public static readonly ScapinScreenScannerLink = 'https://www.kogeet.com/scapin-screen-scanner'
  public static readonly DatasetsLink = 'https://kogeet.com/management#datasets'
  public static readonly VariablesLink = 'https://kogeet.com/management#les-variables'
  public static readonly ReleasesLink = 'https://kogeet.com/management#les-releases'
  /**
   * Help for TestCase Workspace
   */
  public static readonly tstcaseLinks: IHelpLink[] = [
    {
      text: 'Take care of Test Case description',
      url: 'https://kogeet.com/quoi-comment#redaction-cas-de-test'
    },
    {
      text: 'How to duplicate a Test Case?',
      url: 'https://kogeet.com/quoi-comment#duplication-cas-de-test'
    },
    {
      text: `Locking Test Cases`,
      url: 'https://kogeet.com/quoi-comment#verrouillage-cas-de-test'
    }
  ]

  /**
   * Help for TestGoals Workspace
   */
  public static readonly tstgoaLinks: IHelpLink[] = [
    {
      text: 'Why the Tests Goals and how to write them?',
      url: 'https://kogeet.com/quoi-comment#write-testgoals'
    },
  ]

  /**
   * Help for TestJobs Workspace
   */
  public static readonly tstjobsLinks: IHelpLink[] = [
    {
      text: 'Start a test campaign',
      url: 'https://kogeet.com/quoi-comment#campagne-de-test'
    },
    {
      text: 'Rules for constituting the Test Set',
      url: 'https://kogeet.com/quoi-comment#jeu-de-tests'
    },
    {
      text: `Configure the launch of a test campaign`,
      url: 'https://kogeet.com/quoi-comment#lancement-campagne'
    },
    {
      text: `The statuses of a test campaign`,
      url: 'https://kogeet.com/quoi-comment#status-campagne'
    },
    {
      text: `Test campaign execution reporting`,
      url: 'https://kogeet.com/quoi-comment#reporting-execution'
    },
    {
      text: 'Prepare your test terminals',
      url: onlineHelp.TestTerminalsLink
    },
  ]

  /**
   * Help for all Workspaces
   */
  public static readonly treelinks: IHelpLink[] = [
    {
      text: `Some general information about tree structures`,
      url: 'https://kogeet.com/quoi-comment#tree-infos'
    },
    {
      text: `How to move cards or folders in the tree structure?`,
      url: 'https://kogeet.com/quoi-comment#moves-in-tree'
    },
  ]

  /**
   * Help for StepBuilder
   */
  public static readonly stepbuilder: IHelpLink[] = [
    {
      text: `Overview of StepBuilder`,
      url: 'https://www.kogeet.com/guide-construction-cas-de-test'
    },
    {
      text: 'Expressions in parameters',
      url: 'https://kogeet.com/stepbuilder#les-expressions'
    },
    {
      text: `Graphic elements and accessories`,
      url: 'https://kogeet.com/elements-and-accessories'
    },
    {
      text: `List of graphic elements`,
      url: 'https://kogeet.com/elements-and-accessories#types-graphiques'
    },
    {
      text: `List of accessories`,
      url: 'https://kogeet.com/elements-and-accessories#types-accessoires'
    },
    { text: '', url: ''},
    {
      text: `Copy and paste test portions into StepBuilder`,
      url: 'https://kogeet.com/stepbuilder#copier-coller'
    },
    {
      text: `What are Rushes and how to use them?`,
      url: 'https://kogeet.com/stepbuilder#les-rushs'
    },
    {
      text: `Debug your tests for automation`,
      url: 'https://kogeet.com/stepbuilder#debogage-des-tests'
    }
  ]
}
